import React from 'react';
import { getDefaultCompanyRoleModel } from './models';
import { getClientRelatedData } from './clients';
import DetailedSelectOption from '../../../components/shared/DetailedSelectOption';
import RolesList from '../../../components/pages/users/RolesList';
export const getCompanyRelatedData = (clientCompaniesRoles, clientId, companyId) => {
    const { companyRoles } = getClientRelatedData(clientCompaniesRoles, clientId);
    return companyRoles.find(x => x.companyId === companyId) || getDefaultCompanyRoleModel();
};
export const getUserCompanyOption = (companyName, companyRoles, companyId) => ({
    value: companyId !== null && companyId !== void 0 ? companyId : companyName,
    renderOption: (<DetailedSelectOption name={companyName} details={<RolesList roles={companyRoles}/>}/>),
    disabled: companyRoles.length === 0
});
